module.exports = __webpack_public_path__ + "static/console-12823363837572176c1b91425c1db14c.mp4";